<template>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Perfil</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="edit">
                    <v-icon>mdi-account-edit</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card>
                <v-card-title>
                <v-list-item-avatar>
                    <v-img :src="user.avatar"></v-img>
                </v-list-item-avatar>
                <span class="headline">{{ user.name }}</span>
                </v-card-title>
                <v-card-subtitle style="margin-top: 8px">
                <p>Empresa: {{ user.business }}</p>
                <p>Almacen: {{ address }}</p>
                <p>Vehículos: {{ user.vehicles }}</p>
                <div style="margin-left: 30px">
                    <p>Pedidos máximos por vehículo: {{ user.ordersPerVehicle }}</p>
                    <p>Horas máximas de ruta por vehículo: {{ user.hoursPerVehicle }}</p>
                    <p>Minutos de servicio: {{ user.serviceMinutes }}</p>
                </div>
                </v-card-subtitle>
                <hr>
                <l-map 
                  id="profileMap"
                  ref="profileMap"
                  :zoom="zoom"
                  :center="center"
                  :minZoom="minZoom"
                  :maxZoom="maxZoom"
                  @click="saveLocation"
                  @update:center="centerUpdate"
                  @update:zoom="zoomUpdate"
                >
                    <l-tile-layer :url="url"></l-tile-layer>
                    <l-marker :lat-lng="depot" ref="depot">
                        <l-icon
                            class-name="depotIcon"
                            :icon-size="dynamicSize"
                            :icon-anchor="dynamicAnchor"
                            icon-url="/img/depotImage.png"
                        />        
                    </l-marker>
                </l-map>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>

/* eslint-disable */
import DialogBox from '../components/DialogBox';
import { Auth } from '../firebase/auth';
import { DB } from '../firebase/db';
import * as L from 'leaflet'; 
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LIcon} from 'vue2-leaflet';
import { getAddressFromCoords } from '../routingservice/RoutingService'

export default {
    name: 'profile',
    components: { 
    LMap, 
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LIcon,
    DialogBox
    },

    data: () => ({
    // Propiedades del mapa
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 13,
      minZoom: 11,
      maxZoom: 17,
      center: [40.962267310600694, -5.6665274472274465],
      bounds: null,
      showParagraph: false,
      withPopup: L.latLng(40.962267310600694, -5.6665274472274465),
      withTooltip: L.latLng(40.956631, -5.6798597),
      showMap: true,
      marker: [0, 0],
      depot: L.latLng(0, 0),
      address: null,
      iconSize: 64,
      email: null,
      user: {},
      //
      title: "Perfil",
      realtimeUnsub : undefined,
      loading : true,
      dialog: false,
      show: false,
    }),

    async created() {
        
        this.depot = await this.getCurrentPos();
        this.centerUpdate(this.depot);

        let user = await Auth.getCurrentUser();
        console.log(user.uid);
        this.user = user;
        this.email = user.email;

        console.log("Depot Lat: ", this.depot[0]);
        console.log("Depot: ", this.depot);

        let newDepot = {
            lat: this.depot[0],
            lng: this.depot[1]
        }

        let dbUser = await DB
        .collection("users")
        .doc(user.uid)
        .get()
        .then(async doc => {
            if (!doc.exists) {
                console.log('The user doesn\'t exists or bad configuration');
            } else {
                if(doc.get('location') != null && doc.get('address') != null) {
                    console.log("User exists and has location: ", doc.data());
                    this.user = doc.data();
                    this.depot = doc.data().location;
                    this.address = doc.data().address;
                    console.log("Depot in get Location: ", this.depot, this.address);
                    this.centerUpdate(this.depot);
                } else {
                    console.log("Address or location do not exist: ", doc.data());
                    console.log("Depot in set location: ", this.depot);
                    const response = await getAddressFromCoords(newDepot);
                    console.log("Address when user has no location: ", response.features[0].properties.label); 
                    this.address = response.features[0].properties.label;
                    try {
                        var result = await DB.collection('users').doc(user.uid).set({
                            location: newDepot,
                            address: this.address,
                        },
                        { merge: true });
                        console.info("Location for " + user.uid + " added in firestore database succesfully.");
                    }
                    catch(error){
                        console.error("Error adding user " + user.uid + " in firestore database:\n" + error);
                    }
                }
            }
            this.show = true;
        }).catch(err => {
            console.log('Error getting document', err);
        });

    },

    computed: {
        // Establece de forma dinámica el tamaño de los markers
        dynamicSize() {
            let zoomNormalizado = 1-(this.zoom/this.maxZoom);
            let reduction = 6;
            let scale = (1 / zoomNormalizado ) / reduction;
            
            if (scale > 1.4)
                scale = 1.10;

            return [this.iconSize*scale, this.iconSize*scale];
        },
        dynamicAnchor() {
            return [10, 10];
        }
    },

    methods: {
        async getCurrentPos() {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition( position => {
                    const currentPosition = [ position.coords.latitude, position.coords.longitude ];
                    resolve(currentPosition);
                },
                error => {
                    reject(error);
                })
            })
        },

        close() {
            this.$router.go(-1)
        },

        edit() {
            this.$router.push('/edit-profile')
        },
    
        zoomUpdate (zoom) {
            this.zoom = zoom;
        },
        
        centerUpdate (center) {
            console.log("Center: ", center);
            this.center = center;
        },
        
        boundsUpdated (bounds) {
            this.bounds = bounds;
        },

        async saveLocation(event) {
            console.log(event)
            let newDepot = {
                lat: event.latlng.lat,
                lng: event.latlng.lng,
            }
            this.depot = newDepot;

            const response = await getAddressFromCoords(newDepot);
            console.log("Response in Profile: ", response);
            console.log("Direccion: ", response.features[0].properties.label); 
            this.address = response.features[0].properties.label;

            try {
                var result = await DB.collection('users').doc(this.user.uid).set({
                    location: newDepot,
                    address: this.address,
                },
                { merge: true });
                console.info("Location for " + this.user.uid + " added in firestore database succesfully.");
                
            }
            catch(error){
                console.error("Error adding user " + this.user.uid + " in firestore database:\n" + error);
            }
        },
    }
}
</script>

<style scoped>

    .depotIcon {
        padding: 3px;
        border: 1px solid #333;
        border-radius: 0 50% 50% 50%;
        box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
        text-align: center;
        margin: 0 !important;
    }

    #profileMap {
        width: 100vw;
        height: 53vh;
    }


</style>